<template>
    <div>
        <app-breadcrumb />
        <div class="page-container service-fee-management">
            <div class="filter">
                <el-form :inline="true" :model="listQuery" size="mini">
                    <el-form-item label="月份:">
                        <el-select v-model="listQuery.wMonthStart" v-loading="doLoading" placeholder="月份开始" clearable>
                            <el-option value="" />
                            <el-option v-for="i in monthList" :key="i" :label="i" :value="i" />
                        </el-select>
                        -
                        <el-select v-model="listQuery.wMonthEnd" v-loading="doLoading" placeholder="月份结束" clearable>
                            <el-option value="" />
                            <el-option v-for="i in monthList" :key="i" :label="i" :value="i" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button :loading="loading" type="primary" plain icon="el-icon-search"
                            @click="handleFilter">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table v-loading="loading" :data="list" style="width: 100%" size="mini" border fit highlight-current-row>
                <!-- <el-table-column label="经销商编号" prop="memberNo" align="center" /> -->
                <el-table-column label="月度" prop="wMonth" align="center" />
                <el-table-column label="第1周" prop="oneBonus" align="center" />
                <el-table-column label="第2周" prop="twoBonus" align="center" />
                <el-table-column label="第3周" prop="threeBonus" align="center" />
                <el-table-column label="第4周" prop="fourBonus" align="center" />
                <el-table-column label="第5周" prop="fiveBonus" align="center" />
                <el-table-column label="合计" prop="totalBonus" align="center" />
                <el-table-column label="70%" prop="totalBonusPart1" align="center">
                    <template slot-scope="{row}">
                        <el-popover placement="bottom" trigger="click">
                            <div>
                                <p v-if="row.part1SendStatus == 0" style="color: red;text-align: center;">未发放</p>
                                <p v-else style="color: green;text-align: center">已发放</p>
                            </div>
                            <div slot="reference">
                                <p v-if="row.part1SendStatus == 0"
                                    style="color: red;text-align: center;cursor: pointer;">
                                    {{ row.totalBonusPart1 }}</p>
                                <p v-else style="color: green;text-align: center;cursor: pointer;">
                                    {{ row.totalBonusPart1 }}</p>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="30%" prop="totalBonusPart2" align="center">
                    <template slot-scope="{row}">
                        <el-popover placement="bottom" trigger="click">
                            <div>
                                <p v-if="row.part2SendStatus == 0" style="color: red;text-align: center;">未发放</p>
                                <p v-else style="color: green;text-align: center">已发放</p>
                            </div>
                            <div slot="reference">
                                <p v-if="row.part2SendStatus == 0"
                                    style="color: red;text-align: center;cursor: pointer;">
                                    {{ row.totalBonusPart2 }}</p>
                                <p v-else style="color: green;text-align: center;cursor: pointer;">
                                    {{ row.totalBonusPart2 }}</p>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="查看发票" prop="orderNo" align="center">
                    <template slot-scope="{row}">
                        <el-button :loading="loading" v-if="row.invoiceStatus == 0" style="width: 100%;" type="danger"
                            plain size="mini" icon="el-icon-upload2" @click="openDialog(row)">待上传</el-button>
                        <el-button :loading="loading" v-else style="width: 100%;" type="primary" plain size="mini"
                            @click="openDialog(row)">查看发票</el-button>
                    </template>
                </el-table-column>

                <el-table-column label="发票状态" prop="invoiceCheckStatus" align="center">
                    <template slot-scope="{row}">
                        <span v-if="row.invoiceStatus == 0 && row.invoiceCheckStatus == 0">待上传</span>
                        <span v-if="row.invoiceStatus == 1 && row.invoiceCheckStatus == 0">待审核</span>
                        <span v-if="row.invoiceCheckStatus == 1">初审通过</span>
                        <span v-if="row.invoiceCheckStatus == 4">初审驳回,原因:{{ row.invoiceCheckRemark }}</span>
                        <span v-if="row.invoiceCheckStatus == 2">二审通过</span>
                        <span v-if="row.invoiceCheckStatus == 5">二审驳回,原因:{{ row.invoiceRecheckRemark }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
                :close-on-click-modal="false" @pagination="getList" />
            <el-dialog title="发票" :visible.sync="dialogVisible" width="50%" :show-close="false">
                <div v-show="dialogType === 'upload'">
                    <div
                        v-if="dialogData.invoiceCheckStatus == 0 || dialogData.invoiceCheckStatus == 4 || dialogData.invoiceCheckStatus == 5">
                        <el-upload :action="uploadUrl" multiple :show-file-list="false" :headers="headers"
                            :before-upload="(file) => beforeUpload(file)"
                            :on-progress="(event, file, fileList) => uploadProgress(event, file, fileList)"
                            :on-success="(response, file, fileList) => uploadSuccess(response, file, fileList)"
                            :on-error="(err, file, fileList) => uploadError(err, file, fileList)">
                            <div>只支持 JPG、PNG、PDF 和 OFD 格式的文件，OFD文件不支持预览</div>
                            <el-button :loading="loading" size="small" type="primary">点击上传新发票</el-button>
                        </el-upload>
                    </div>
                    <div v-show="addList.length > 0">
                        <p>待保存的发票:</p>
                        <table style="margin: 0 auto;">
                            <tr v-for="item in addList" :key="item.id">
                                <td>
                                    <span v-if="item.isView" style="color: red;">(上次查看)</span>
                                </td>
                                <td>
                                    <el-button size="mini" type="primary" plain
                                        v-if="item.invoiceUrl.indexOf('.ofd') === -1"
                                        @click="viewInvoice(item)">查看</el-button>
                                </td>
                                <td>
                                    <a :href="item.invoiceUrl" target="_blank">{{ getFileName(item.invoiceUrl) }}</a>
                                </td>
                                <td>
                                    <el-button size="mini" type="danger" plain
                                        @click="removeInvoice(item, addList)">删除</el-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div v-show="dialogData.details.length > 0">
                        <p>
                            已上传的发票:
                        </p>
                        <table style="margin: 0 auto;">
                            <tr v-for="item in dialogData.details" :key="item.id">
                                <td>
                                    <span v-if="item.isView" style="color: red;">(上次查看)</span>
                                </td>
                                <td>
                                    <el-button size="mini" type="primary" plain
                                        v-if="item.invoiceUrl.indexOf('.ofd') === -1"
                                        @click="viewInvoice(item)">查看</el-button>
                                </td>
                                <td>
                                    <a :href="item.invoiceUrl" target="_blank">{{ getFileName(item.invoiceUrl) }}</a>
                                </td>
                                <td>
                                    <el-button
                                        v-if="dialogData.invoiceCheckStatus == 0 || dialogData.invoiceCheckStatus == 4 || dialogData.invoiceCheckStatus == 5"
                                        size="mini" type="danger" plain
                                        @click="removeInvoice(item, dialogData.details)">删除</el-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div style="text-align: right;margin-top: 10px;">
                        <el-button :loading="loading" @click="dialogClose()">取 消</el-button>
                        <el-button
                            v-if="dialogData.invoiceCheckStatus == 0 || dialogData.invoiceCheckStatus == 4 || dialogData.invoiceCheckStatus == 5"
                            :loading="loading" type="primary" @click="invoiceSave">保 存</el-button>
                    </div>
                </div>
                <div v-show="dialogType === 'view'">
                    <div>
                        文件预览
                    </div>
                    <div v-loading="loading">
                        <vue-office-pdf v-if="invoiceUrl.indexOf('.pdf') !== -1" :src="invoiceUrl" style="height: 500px"
                            @rendered="renderedHandler" @error="errorHandler" />
                        <div v-else-if="invoiceUrl.indexOf('.ofd') !== -1">
                            OFD文件类型暂不支持预览
                        </div>
                        <img v-else :src="invoiceUrl" style="max-width: 100%;max-height: 500px;" alt="图片" />
                    </div>
                    <div style="text-align: right;margin-top: 10px;">
                        <el-button :loading="loading" @click="dialogType = 'upload'">返 回</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { pageByDTO, viewById, invoiceCommit } from '@/api/bd/cashBonuslist'
import { monthList } from '@/api/common/common'
import Pagination from '@/components/Pagination'
import VueOfficePdf from '@vue-office/pdf'
export default {
    name: 'ServiceFeeManagement',
    components: { Pagination, VueOfficePdf },
    data() {
        return {
            monthList: [],
            dialogType: 'upload',
            invoiceUrl: '',
            invoiceUrlHistory: '',
            totalFiles: 0,      // 总文件数
            uploadedFiles: 0,   // 已上传文件数(成功+失败)
            uploadUrl: process.env.VUE_APP_BASE_API + '/upload/uploadFileCommon',
            headers: {
                'Authorization': getToken()
            },
            dialogVisible: false,
            loading: false,
            list: [],
            dialogData: {
                details: [],
            },

            addList: [],
            total: 0,
            listQuery: {
                wMonthStart: '',
                wMonthEnd: '',
                page: 1,
                limit: 10,
            },
            initDict: {
                orderType: 'ac_change_order_type'
            }
        }
    },
    computed: {
        isAgent() {
            return this.$store.state.user.isAgent
        },
    },
    mounted() {
        this.getMonthList()
    },
    methods: {
        getMonthList() {
            this.loading = true
            monthList().then(res => {
                this.monthList = res.data
                this.loading = false
            }).catch(err => {
                console.warn(err)
                this.loading = false
            })
        },
        getList() {
            const fromDate = this.listQuery.startTime
            const toDate = this.listQuery.endTime
            this.loading = true
            pageByDTO({ ...this.listQuery, fromDate, toDate }).then(res => {
                this.list = res.data.records
                this.total = +res.data.total || 0
                this.loading = false
            }).catch(err => {
                console.warn(err)
                this.loading = false
            })
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList()
        },
        async openDialog(row) {
            this.loading = true
            let { data } = await viewById({ id: row.id })
            this.dialogData = data
            if (data.details && data.details.length > 0) {
                data.details.forEach(item => {
                    item.isView = false
                })
            }
            this.addList = []
            this.loading = false
            this.dialogVisible = true
        },

        checkAllFilesUploaded() {
            if (this.uploadedFiles === this.totalFiles && this.totalFiles > 0) {
                console.log('所有文件上传完成');
                // 可以在这里触发相应的操作
                // 重置计数器以便下次上传
                this.totalFiles = 0;
                this.uploadedFiles = 0;
                this.loading = false;
            }
        },
        beforeUpload(file) {

            // 支持的文件类型：JPG、PNG、GIF、PDF、OFD
            const validFileTypes = [
                'image/jpeg',
                'image/png',
                'application/pdf',
                'application/ofd'  // OFD文件类型
            ];

            const isValidType = validFileTypes.includes(file.type) || file.name.indexOf('.ofd') !== -1;

            if (!isValidType) {
                this.$message.error('只支持 JPG、PNG、PDF 和 OFD 格式的文件!');
                return false;
            }

            this.totalFiles++;
            this.uploadedFiles = 0;
            return true;
        },
        uploadProgress(event, file, fileList) {
            this.loading = true
            console.log(event, 'uploadProgress');
            console.log(file, 'uploadProgress');
            console.log(fileList, 'uploadProgress');

        },
        async uploadSuccess(response, file, fileList) {
            // {
            //     "msg": "上传成功",
            //     "errno": 0,
            //     "data": {
            //            "alt": "",
            //            "href": "",
            //            "url": "http://54.151.252.100:9000/file-co/20251027_669fbf4a-0e10-47b5-a72d-b5feb6a8f475.jpg"
            //     }
            // }
            this.addList.push({
                orderId: this.dialogData.id,
                invoiceUrl: response.data.url
            })
            console.log(response, 'uploadSuccess');
            console.log(file, 'uploadSuccess');
            console.log(fileList, 'uploadSuccess');
            this.uploadedFiles++;
            this.checkAllFilesUploaded();

        },
        uploadError(err, file, fileList) {
            console.log(err, 'uploadError');
            console.log(file, 'uploadError');
            console.log(fileList, 'uploadError');
            this.uploadedFiles++;
            this.checkAllFilesUploaded();

        },
        invoiceSave() {
            this.loading = true
            let data = {
                id: this.dialogData.id,
                details: [...this.dialogData.details, ...this.addList]
            }
            invoiceCommit(data).then(res => {
                this.$message.success('保存成功')
                this.getList()
                this.addList = []
                console.log(res, 'invoiceCommit');

            }).catch(err => {
                console.warn(err)
            }).finally(() => {
                this.loading = false
                this.dialogVisible = false
            })
        },
        removeInvoice(item, list) {
            list.splice(list.indexOf(item), 1)
        },
        getFileName(invoiceUrl) {
            if (!invoiceUrl) {
                return ''
            }
            return invoiceUrl.substring(invoiceUrl.lastIndexOf('/') + 1)
        },
        viewInvoice(file) {
            if (this.dialogData.details && this.dialogData.details.length > 0) {
                this.dialogData.details.forEach(item => {
                    item.isView = false
                })
            }
            if (this.addList && this.addList.length > 0) {
                this.addList.forEach(item => {
                    item.isView = false
                })
            }
            file.isView = true
            this.invoiceUrl = file.invoiceUrl
            this.dialogType = 'view'
            if (file.invoiceUrl.indexOf('.pdf') !== -1 && this.invoiceUrlHistory !== file.invoiceUrl) {
                this.invoiceUrlHistory = file.invoiceUrl
                this.loading = true
            }

        },
        renderedHandler() {
            console.log("渲染完成")
            this.loading = false
        },
        errorHandler() {
            console.log("渲染失败")
        },
        dialogClose() {
            if (this.addList && this.addList.length > 0) {
                this.$confirm('已上传未保存,是否保存?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.invoiceSave()
                }).catch(() => {
                    this.$message.info('已取消保存')
                    this.dialogVisible = false
                })
            }
            else {
                this.dialogVisible = false
            }
        }
    }
}
</script>

<style lang="scss"></style>
